import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { clsx, Popover } from '@a-type/ui';
import { useMemo, useRef, useState, useSyncExternalStore } from 'react';
import { droppableDataRegistry } from '../dnd/dataRegistry.js';
import { Droppable, useParentDroppable, } from '../dnd/Droppable.js';
import { useMergedRef } from '../hooks/useMergedRef.js';
import cls from './TokenSpace.module.css';
import { isToken } from './types.js';
const tokenSpaceTags = ['token-space'];
export function TokenSpace({ id, children, className, onDrop, type, accept, onReject, onNonTokenReject, onOver, onOverAccepted, tags, validationMessageClassName, ref: userRef, ...rest }) {
    const [overError, setOverError] = useState(null);
    const wrappedAccept = (data, gesture) => {
        // only accept tokens
        if (!isToken(data.data)) {
            console.log('not token', data.data);
            return false;
        }
        // do not accept tokens already in this space
        if (gesture.draggedFrom === id) {
            return false;
        }
        if (!accept)
            return true;
        return accept(data.data) === true;
    };
    const wrappedOnReject = (data, gesture) => {
        if (!isToken(data.data)) {
            console.debug(`TokenSpace: rejecting non-token data ${data.id}`);
            return onNonTokenReject?.(data);
        }
        if (gesture.draggedFrom === id) {
            console.debug(`TokenSpace: rejecting token ${data.id} that is already in this space`);
            // do not notify user of tokens already in this space
            return;
        }
        return onReject?.(data.data);
    };
    const handleOver = (data) => {
        if (!data) {
            onOver?.(null);
            onOverAccepted?.(null);
            setOverError(null);
            return;
        }
        if (data && isToken(data.data)) {
            onOver?.(data.data);
        }
        if (!isToken(data.data)) {
            setOverError(null);
            return;
        }
        if (!accept) {
            onOverAccepted?.(data.data);
            setOverError(null);
            return;
        }
        const result = accept(data.data);
        if (typeof result === 'string') {
            setOverError(result);
        }
        else {
            setOverError(null);
            onOverAccepted?.(data.data);
        }
    };
    const data = useMemo(() => ({ isTokenSpace: true, type }), [type]);
    const anchorRef = useRef(null);
    const finalRef = useMergedRef(anchorRef, userRef);
    return (_jsxs(Popover, { open: !!overError, children: [_jsx(Droppable, { id: id, ref: finalRef, className: clsx(cls.root, className), onDrop: (droppable, gesture) => onDrop?.(droppable.data, gesture), accept: wrappedAccept, onReject: wrappedOnReject, onOver: handleOver, tags: tokenSpaceTags, data: data, ...rest, children: children }), _jsxs(Popover.Content, { anchor: anchorRef, side: "top", align: "center", sideOffset: 8, className: clsx(cls.error, '@mode-attention'), children: [_jsx(Popover.Arrow, {}), overError] })] }));
}
export function useMaybeParentTokenSpace() {
    const parentId = useParentDroppable();
    const data = useSyncExternalStore((cb) => droppableDataRegistry.subscribe(`update:${parentId}`, cb), () => (parentId ? droppableDataRegistry.get(parentId) : null), () => (parentId ? droppableDataRegistry.get(parentId) : null));
    if (!parentId) {
        return null;
    }
    if (!data || data.tokenSpace) {
        return null;
    }
    return data;
}
//# sourceMappingURL=TokenSpace.js.map